import React from 'react';
import PageWrapper from '../../components/UI/PageWrapper';
import InvitationsList from '../../components/Admin/InvitationsList';

const InvitationsListPage = () => (
  <PageWrapper>
    <InvitationsList />
  </PageWrapper>
);

export default InvitationsListPage;

